/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = 0;

const tabValueSlice = createSlice({
    name: 'tabValueForm',
    initialState: initialState,
    reducers: {
        setTabValueData: (state, action) => {
            return action.payload;
        },
        resetTabValueData: () => {
            return initialState;
        },
    },
});

export const { setTabValueData, resetTabValueData } = tabValueSlice.actions;
export default tabValueSlice.reducer;
